import {Component, Inject, Input, OnInit} from '@angular/core';

import { CaseModel } from '@app/ps/models/case.model';
import { CaseService } from '@app/ps/services/case.service';
import { StateService } from '@uirouter/angular';
import { Restangular } from 'ngx-restangular';
import { CaseStatusService } from '@app/ps/services/case-status.service';
import { APP_BRAND } from '@app/common/services/config.service';
import {CaseSubjectModel} from "@app/ps/models/case-subject.model";
import {DialogService} from "@app/common/services/dialog.service";

@Component({
  selector: 'accepted-geometrical-plan-possible',
  templateUrl: './accepted-geometrical-plan-possible.component.html',
})
export class AcceptedGeometricalPlanPossibleComponent implements OnInit {
  @Input() caseId: number;
  public loading = true;
  public data: CaseModel;
  public recipient: any;
  acceptedGeometricalPlanPossibleName: string;
  existsAcquisitionDeed = true;
  alreadySigned = 0;

  constructor(
    private caseService: CaseService,
    private stateService: StateService,
    private restangular: Restangular,
    private caseStatusService: CaseStatusService,
    private dialogService: DialogService,
    @Inject(APP_BRAND) private APP_BRAND: any,
  ) {
    this.onSubjectSignDateChanged = this.onSubjectSignDateChanged.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async ngOnInit() {
    this.acceptedGeometricalPlanPossibleName = (await this.caseStatusService.loadStatusName('AcceptedGeometricalPlanPossible')).name;
    this.data = await this.restangular.one('cases', this.caseId).get({loadCollections: ['caseSubjects', 'caseOwnerships']}).toPromise();
    this.alreadySigned = this.data.caseSubjects.filter(subject => subject.acceptedGeometricalPlanPossibleDate).length;

    if (this.APP_BRAND.NAME === 'RSD') {
      this.existsAcquisitionDeed = await this.caseService.existsAcquisitionDeed(this.caseId);
    }

    this.loading = false;
  }

  onSubjectSignDateChanged(caseSubject: CaseSubjectModel) {
    const aquisionDeedNeeded = this.APP_BRAND.NAME === 'RSD'
      && !this.existsAcquisitionDeed
      && this.data.caseSubjects.filter(subject => subject.acceptedGeometricalPlanPossibleDate).length > this.alreadySigned;

    if (aquisionDeedNeeded) {
      this.caseService.acquisitionDeedNeeded(this.caseId);

      const msg = `Datum podpisu poslední smluvní strany nelze uložit. V dokumentech k případu chybí nabývací listina. Nedojde ke změně stavu případu.`;
      this.dialogService.alertDialogPromise(msg)
        .then(() => {
          caseSubject.acceptedGeometricalPlanPossibleDate = undefined;
        });
    }
  }

  isValid() {
    return this.data.responseReceivedDate
      && this.data.caseSubjects.filter(subject => subject.acceptedGeometricalPlanPossibleDate).length > this.alreadySigned;
  }

  async onSubmit(): Promise<any> {
    const sendData = {
      responseReceivedDate: this.data.responseReceivedDate,
      caseSubjects: this.data.caseSubjects,
    };
    await this.restangular
      .one('cases', this.caseId)
      .customPUT(sendData, 'accepted-geometrical-plan-possible')
      .toPromise();

    this.stateService.go('^');
  }
}

